module.exports = __webpack_public_path__ + "h5/static/img/bwhale-logo.ab2c97de.png";